<template>
  <div>
    <div>
      <top-item-com active="7" :ssid="ssid"></top-item-com>
    </div>
    <div style="padding: 10px;background: #185F9B;text-align: left;">
      <van-field
        v-model="search.info"
        left-icon="search"
        center
        clearable
        label=""
        placeholder="请输入运动员信息"
      >
        <template #button>
          <van-button size="small" type="primary" @click="searchHandler"
            >检索</van-button
          >
        </template>
      </van-field>

      <div style="padding-top:15px;padding-bottom:10px;">
        <label class="dropClass" @click="openBsztModal">
          <span>{{
            bsztSelectData.name === "全部" ? "比赛状态" : bsztSelectData.name
          }}</span
          ><van-icon name="arrow-down" />
        </label>
        <label class="dropClass" @click="openSslxModal">
          <span>{{
            sslxSelectData.name === "全部" ? "项目类型" : sslxSelectData.name
          }}</span
          ><van-icon name="arrow-down" />
        </label>
      </div>
    </div>

    <!-- 日期筛选器 -->
    <div class="date-filter-container">
      <div class="date-filter-scroll">
        <!-- 全部选项 -->
        <div
          :class="[
            'date-item',
            'date-item-all',
            { active: selectedDate === '' }
          ]"
          @click="selectDate('')"
        >
          <div class="date-all-text">全部</div>
        </div>
        <!-- 日期列表 -->
        <div
          v-for="(date, index) in dateList"
          :key="index"
          :class="['date-item', { active: selectedDate === date }]"
          @click="selectDate(date)"
        >
          <div class="date-day">{{ formatDateDay(date) }}</div>
          <div class="date-month">{{ formatDateMonth(date) }}</div>
        </div>
      </div>
    </div>

    <div v-if="ISSHOWCDH === '1'">
      <van-tabs type="card" v-model="cdhActive" @change="searchHandler">
        <van-tab title="全部" name=""></van-tab>
        <van-tab
          v-for="(item, index) in CDHLIST"
          :key="index"
          :title="item.CDH + '号场地'"
          :name="item.CDH"
        ></van-tab>
      </van-tabs>
    </div>

    <div v-for="(mainItem, mainIndex) in dataList" :key="mainIndex">
      <div v-if="mainItem.MXLIST[0].SSLXTYPE === 'T'">
        <!-- 团体赛 开始 -->
        <div
          style="background: #fff;margin-left: 10px;margin-right: 10px;margin-top: 20px;border-radius: 5px;"
        >
          <div
            class="titleMainClass"
            v-bind:style="{
              background:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'rgb(222 222 222)'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? 'blue'
                  : 'green',
              color:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'black'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? '#fff'
                  : '#fff'
            }"
          >
            {{
              mainItem.MXLIST[0].XMJC +
                "(" +
                mainItem.MXLIST[0].SSLXMC +
                ")" +
                mainItem.MXLIST[0].TITLE
            }}
          </div>
          <div style="border-bottom: 1px dashed #ddd;">
            <van-row>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 23px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].TEAMMARK1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="padding-top: 10px;padding-bottom: 5px;font-size: 15px;text-align: center;"
                >
                  {{ "共" + mainItem.MXLIST.length + "场" }}
                </div>
                <div
                  v-bind:style="{
                    paddingBottom: '5px',
                    fontSize: '15px',
                    textAlign: 'center',
                    fontWeight: '600',
                    color:
                      mainItem.MXLIST[0].ISKS == '1'
                        ? 'blue'
                        : mainItem.MXLIST[0].ISKS == '2'
                        ? 'green'
                        : 'red'
                  }"
                >
                  {{
                    mainItem.MXLIST[0].ISKS == "1"
                      ? "正在比赛"
                      : mainItem.MXLIST[0].ISKS == "2"
                      ? "比赛完成"
                      : "未开赛"
                  }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 23px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].TEAMMARK2 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div style="padding-bottom: 10px;border-bottom: 5px solid #ddd;">
            <van-row>
              <van-col span="9">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].RYXM1 }}({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH1
                      : mainItem.MXLIST[0].ZNWZH1
                  }})
                </div>
                <div
                  v-if="mainItem.MXLIST[0].LQRMDCOUNT1 == '0'"
                  style="text-align: center;padding-top: 5px;color: red;font-size: 14px;font-weight: 600;"
                >
                  未填写名单
                </div>
              </van-col>
              <van-col span="6">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  VS
                </div>
                <!-- <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                  v-if="getTeamSumBsys(mainItem.MXLIST) > 0"
                >
                  <span v-html="getTeamSumBsys(mainItem.MXLIST)"></span>
                  <span style="font-size:10px">分钟</span>
                </div> -->
              </van-col>
              <van-col span="9">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].RYXM2 }}({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH2
                      : mainItem.MXLIST[0].ZNWZH2
                  }})
                </div>
                <div
                  v-if="mainItem.MXLIST[0].LQRMDCOUNT2 == '0'"
                  style="text-align: center;padding-top: 5px;color: red;font-size: 14px;font-weight: 600;"
                >
                  未填写名单
                </div>
              </van-col>
            </van-row>
          </div>
          <div
            style="padding-top: 5px;padding-bottom: 5px;"
            v-for="(mxItem, mxIndex) in mainItem.MXLIST"
            :key="mxIndex"
            @click="navToBfMx(mxItem)"
          >
            <van-row
              v-bind:style="{
                padding: '15px',
                background:
                  mxItem.TEAMISKS == '1'
                    ? '#9c6500'
                    : mxItem.TEAMISKS == '2'
                    ? 'green'
                    : '#8a8a8a',
                color:
                  mxItem.TEAMISKS == '1'
                    ? '#fff'
                    : mxItem.TEAMISKS == '2'
                    ? '#fff'
                    : '#fff'
              }"
            >
              <van-col span="12">
                <div style="padding-bottom: 10px;font-size: 14px;">
                  项目：{{ mxItem.TEAMSSLXMC }}({{ mxItem.TEAMSSLX }})
                </div>
                <div style="font-size: 14px;">
                  {{
                    mxItem.TEAMISKS == "1"
                      ? "正在比赛"
                      : mxItem.TEAMISKS == "2"
                      ? "比赛完成"
                      : mainItem.MXLIST[0].ISKS == "2"
                      ? "无效比赛"
                      : "未开赛"
                  }}({{ "第" + (mxIndex + 1) + "场" }})
                </div>
                <div
                  style="margin-top:6px;font-size: 14px;"
                  v-if="mainItem.MXLIST[0].XGCS > -1"
                >
                  您前面还有
                  <span style="color:#22ff08;">{{
                    mainItem.MXLIST[0].XGCS
                  }}</span>
                  场比赛
                </div>
                <div
                  style="margin-top:6px;font-size: 14px;color:#22ff08;"
                  v-if="
                    mainItem.MXLIST[0].XGCS > -1 && mainItem.MXLIST[0].XGCS < 5
                  "
                >
                  *请注意比赛时间及时检录*
                </div>
                <div
                  style="font-size: 14px;margin-top: 13px;"
                  v-if="mxItem.BCYS - 0 > 0"
                >
                  {{ mxItem.BCYS }}
                  <span style="font-size:10px">分钟</span>
                </div>
              </van-col>
              <van-col span="12">
                <div
                  style="font-size: 14px;padding-bottom: 3px;text-align: right;"
                >
                  {{ mainItem.MXLIST[0].RQ }}
                  {{
                    mainItem.MXLIST[0].STARTTIME == "-"
                      ? ""
                      : mainItem.MXLIST[0].STARTTIME
                  }}
                </div>
                <div
                  v-if="mxItem.CXDZH.length > 0"
                  style="font-size: 14px;padding-bottom: 3px;text-align: right;"
                >
                  场序:{{ mxItem.CXDZH }}
                </div>
                <div
                  v-if="mxItem.CDH.length > 0"
                  style="font-size: 14px;padding-bottom: 3px;text-align: right;"
                >
                  {{ mxItem.CDH }}号场地
                </div>
              </van-col>
            </van-row>
            <van-row style="padding:15px;border-bottom: 5px solid #ddd;">
              <van-col span="8">
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 != '0' &&
                      mainItem.MXLIST[0].LQRMDCOUNT2 != '0'
                  "
                >
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    <span
                      v-if="mxItem.ISPF1 === '1' || mxItem.ISDCQQ1 === '1'"
                      style="margin-right: 5px;background: #747474;color: #fff;padding: 3px;border-radius: 5px;"
                    >
                      弃
                    </span>
                    {{ mxItem.TEAMRYXM1 }}
                  </div>
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ mxItem.TEAMRYXM2 }}
                  </div>
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 == '0' ||
                      mainItem.MXLIST[0].LQRMDCOUNT2 == '0'
                  "
                  style="text-align: center;font-size: 17px;"
                >
                  <span
                    v-if="mxItem.ISPF1 === '1' || mxItem.ISDCQQ1 === '1'"
                    style="margin-right: 5px;background: #747474;color: #fff;padding: 3px;border-radius: 5px;"
                  >
                    弃
                  </span>
                  **
                </div>
                <div
                  style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mxItem.MARK1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  v-bind:style="{
                    textAlign: 'center',
                    paddingBottom: '5px',
                    color: mxItem.TEAMISKS == '1' ? 'blue' : 'black'
                  }"
                  v-for="(fxmxItem, fsmxIndex) in mxItem.CJLIST"
                  :key="fsmxIndex"
                >
                  {{ fxmxItem.MXMARK1 }}:{{ fxmxItem.MXMARK2 }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 != '0' &&
                      mainItem.MXLIST[0].LQRMDCOUNT2 != '0'
                  "
                >
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    <span
                      v-if="mxItem.ISPF2 === '1' || mxItem.ISDCQQ2 === '1'"
                      style="margin-right: 5px;background: #747474;color: #fff;padding: 3px;border-radius: 5px;"
                    >
                      弃
                    </span>
                    {{ mxItem.TEAMRYXM3 }}
                  </div>
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ mxItem.TEAMRYXM4 }}
                  </div>
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 == '0' ||
                      mainItem.MXLIST[0].LQRMDCOUNT2 == '0'
                  "
                  style="text-align: center;font-size: 17px;"
                >
                  **
                  <span
                    v-if="mxItem.ISPF2 === '1' || mxItem.ISDCQQ2 === '1'"
                    style="margin-right: 5px;background: #747474;color: #fff;padding: 3px;border-radius: 5px;"
                  >
                    弃
                  </span>
                </div>
                <div
                  style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mxItem.MARK2 }}
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
        <!-- 团体赛 结束 -->
      </div>
      <div
        v-if="mainItem.MXLIST[0].SSLXTYPE !== 'T'"
        @click="navToBfMx(mainItem.MXLIST[0])"
      >
        <!-- 单项赛 开始 -->
        <div
          style="background: #fff;margin-left: 10px;margin-right: 10px;margin-top: 20px;border-radius: 5px;"
        >
          <div
            class="titleMainClass"
            v-bind:style="{
              background:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'rgb(222 222 222)'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? 'blue'
                  : 'green',
              color:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'black'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? '#fff'
                  : '#fff'
            }"
          >
            {{ mainItem.MXLIST[0].XMJC }}（{{ mainItem.MXLIST[0].SSLXMC }}）
            {{ mainItem.MXLIST[0].TITLE }}
          </div>
          <div style="border-bottom: 1px dashed #ddd;">
            <van-row>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 10px;font-size: 23px;font-weight: 600;padding-bottom:6px;"
                >
                  {{ mainItem.MXLIST[0].MARK1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div style="text-align: center;">
                  {{ "共" + mainItem.MXLIST[0].JS + "局" }}
                </div>
                <div
                  v-bind:style="{
                    paddingBottom: '5px',
                    fontSize: '15px',
                    textAlign: 'center',
                    fontWeight: '600',
                    color:
                      mainItem.MXLIST[0].ISKS == '1'
                        ? 'blue'
                        : mainItem.MXLIST[0].ISKS == '2'
                        ? 'green'
                        : 'red'
                  }"
                >
                  {{
                    mainItem.MXLIST[0].ISKS == "1"
                      ? "正在比赛"
                      : mainItem.MXLIST[0].ISKS == "2"
                      ? "比赛完成"
                      : "未开赛"
                  }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 10px;font-size: 23px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].MARK2 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div style="padding-top: 5px;padding-bottom: 5px;">
            <van-row style="padding:3px;border-bottom: 1px solid #ddd;">
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].DWJC1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div style="text-align: center;padding-bottom: 5px;">
                  队伍名称
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].DWJC2 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div style="padding-top: 5px;padding-bottom: 5px;">
            <van-row style="padding:5px;border-bottom: 1px solid #ddd;">
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  <span
                    v-if="
                      mainItem.MXLIST[0].ISPF1 === '1' ||
                        mainItem.MXLIST[0].ISDCQQ1 === '1'
                    "
                    style="margin-right: 5px;background: #747474;color: #fff;padding: 3px;border-radius: 5px;"
                    >弃</span
                  >
                  {{ mainItem.MXLIST[0].TEAMRYXM1 }}
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].TEAMRYXM2 &&
                      mainItem.MXLIST[0].TEAMRYXM2.length > 0 &&
                      mainItem.MXLIST[0].TEAMRYXM2 !== '-'
                  "
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM2 }}
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].TEAMRYXM_FIN1 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN1.length > 0 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN1 !== '-'
                  "
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM_FIN1 }}
                </div>
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  （{{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH1 +
                        "号"
                      : mainItem.MXLIST[0].ZNWZH1
                  }})
                </div>
              </van-col>
              <van-col span="8">
                <div style="text-align: center;padding-bottom: 5px;">VS</div>
                <div
                  style="text-align: center;padding-bottom: 5px;margin-top:5px"
                >
                  {{ mainItem.MXLIST[0].BCYS }}
                  <span style="font-size:10px">分钟</span>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  <span
                    v-if="
                      mainItem.MXLIST[0].ISPF2 === '1' ||
                        mainItem.MXLIST[0].ISDCQQ2 === '1'
                    "
                    style="margin-right: 5px;background: #747474;color: #fff;padding: 3px;border-radius: 5px;"
                    >弃</span
                  >
                  {{ mainItem.MXLIST[0].TEAMRYXM3 }}
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].TEAMRYXM4 &&
                      mainItem.MXLIST[0].TEAMRYXM4.length > 0 &&
                      mainItem.MXLIST[0].TEAMRYXM4 !== '-'
                  "
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM4 }}
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].TEAMRYXM_FIN2 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN2.length > 0 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN2 !== '-'
                  "
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM_FIN2 }}
                </div>
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  ({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH2 +
                        "号"
                      : mainItem.MXLIST[0].ZNWZH2
                  }})
                </div>
              </van-col>
            </van-row>
            <!-- 局内比分 开始 -->
            <div
              style="text-align: center;padding: 5px;border-bottom: 1px solid #ddd;"
            >
              <label
                v-for="(cjItem, cjIndex) in mainItem.MXLIST[0].CJLIST"
                :key="cjIndex"
                v-bind:style="{
                  fontSize: '15px',
                  fontWeight: '600',
                  color:
                    mainItem.MXLIST[0].ISKS === '0'
                      ? 'black'
                      : mainItem.MXLIST[0].ISKS === '1'
                      ? 'blue'
                      : 'green'
                }"
              >
                {{ cjItem.MXMARK1 }}
                :
                {{ cjItem.MXMARK2 }}
                &nbsp;&nbsp;</label
              >
            </div>
            <!-- 局内比分 结束 -->
            <div v-if="false">
              <van-row
                style="padding:15px;border-bottom: 1px solid #ddd;"
                v-for="(cjItem, cjIndex) in mainItem.MXLIST[0].CJLIST"
                :key="cjIndex"
              >
                <van-col span="8">
                  <div
                    style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ cjItem.MXMARK1 }}
                  </div>
                </van-col>
                <van-col span="8">
                  <div style="text-align: center;padding-bottom: 5px;">
                    第{{ cjItem.JSSXH }}局
                  </div>
                </van-col>
                <van-col span="8">
                  <div
                    style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ cjItem.MXMARK2 }}
                  </div>
                </van-col>
              </van-row>
            </div>
            <van-row
              style="padding-left: 15px;padding-right:15px;padding-top:6px;padding-bottom:6px;"
            >
              <van-col span="15">
                <div
                  style="font-size: 15px;font-weight: 600;padding-bottom: 3px;text-align: left;"
                >
                  <span>
                    {{ mainItem.MXLIST[0].RQ }}
                  </span>
                  <span>
                    {{
                      mainItem.MXLIST[0].STARTTIME == "-"
                        ? ""
                        : mainItem.MXLIST[0].STARTTIME
                    }}
                  </span>
                  <span
                    v-if="
                      mainItem.MXLIST[0].CXDZH &&
                        mainItem.MXLIST[0].CXDZH.length > 0
                    "
                  >
                    &nbsp;&nbsp;场序:{{ mainItem.MXLIST[0].CXDZH }}
                  </span>
                </div>
              </van-col>
              <van-col span="9">
                <div
                  v-if="
                    ISSHOWCDH === '1' &&
                      mainItem.MXLIST[0].CDH &&
                      mainItem.MXLIST[0].CDH.length > 0
                  "
                  style="font-size: 15px;font-weight: 600;padding-bottom: 3px;text-align: right;"
                >
                  {{ mainItem.MXLIST[0].CDH }}号场地
                </div>
                <div
                  v-else
                  style="font-size: 15px;font-weight: 600;padding-bottom: 3px;text-align: right;color:red"
                >
                  未公布场地号
                </div>
              </van-col>
            </van-row>
            <van-row
              v-if="mainItem.MXLIST[0].XGCS > -1"
              style="border-top: 1px solid #ddd;padding-top:10px;padding-bottom:5px;"
            >
              <div
                style="font-size: 14px;font-weight: 600;padding-bottom: 3px;text-align: left;padding-left:15px"
              >
                您前面还有
                <span style="font-size:16px;color:red;">
                  {{ mainItem.MXLIST[0].XGCS }} </span
                >场比赛
                <span
                  style="color:red;font-szie:16px;margin-left:6px;"
                  v-if="
                    mainItem.MXLIST[0].XGCS > -1 && mainItem.MXLIST[0].XGCS < 6
                  "
                >
                  *请注意比赛时间及时检录*
                </span>
              </div>
            </van-row>
          </div>
        </div>
        <!-- 单项赛 结束 -->
      </div>
    </div>
    <div
      style="text-align: center;margin-top: 15px;font-size:13px;color:rgb(104, 104, 104)"
      @click="loadingGdHandler"
      v-if="dataList.length > 0"
    >
      <span>{{ isEndPage ? "已加载全部" : "点击加载更多" }}</span>
      <van-icon name="arrow-down" v-if="!isEndPage" />
    </div>
    <van-empty description="数据不存在" v-if="dataList.length === 0" />

    <!--赛事类型  开始-->
    <van-action-sheet
      v-model="sslxVisible"
      :actions="sslxActions"
      @select="onSslxSelect"
    />
    <!--赛事类型  结束-->

    <!--比赛状态  开始-->
    <van-action-sheet
      v-model="bsztShow"
      :actions="bsztActions"
      @select="onBsztSelect"
    />
    <!--比赛状态  结束-->

    <!--底部导航栏  开始-->
    <van-tabbar>
      <van-tabbar-item
        ><van-button round type="warning" @click="refshData">
          实时比分已连接
        </van-button></van-tabbar-item
      >
    </van-tabbar>
    <!--底部导航栏  结束-->

    <!-- 返回顶部按钮 -->
    <div v-if="showBackTop" class="back-to-top" @click="scrollToTop">
      <van-icon name="arrow-up" size="12" />
    </div>

    <div style="height:150px;width:15px;"></div>
    <loading-com></loading-com>
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
import allParam from "../../allParam/allParam.vue";
export default {
  name: "SsbfIndex",
  components: { LoadingCom, TopItemCom, allParam },
  data() {
    return {
      otimer: "",
      utilPost: "",
      ssid: "",
      cdhActive: "",
      dataList: [],
      isEndPage: false,
      pageSet: {
        currentPage: 1, //当前页页码
        totalNums: 0 //数据总条数
      },
      sslxVisible: false,
      sslxActions: [],
      bsztShow: false,
      bsztActions: [
        {
          name: "全部",
          value: ""
        },
        {
          name: "未开赛",
          value: "0"
        },
        {
          name: "比赛中",
          value: "1"
        },
        {
          name: "比赛完成",
          value: "2"
        }
      ],

      search: {
        info: "",
        sslx: "",
        bszt: "",
        cdh: "",
        queryType: "",
        telEn: ""
      },
      sslxSelectData: {
        name: "全部",
        value: ""
      },
      bsztSelectData: {
        name: "比赛中,未开赛",
        value: ""
      },
      CDHLIST: [],
      paramS: "",
      routeValue: "",
      /**socket 通讯 开始 */
      websock: null, //建立的连接
      lockReconnect: false, //是否真正建立连接
      timeout: 3 * 1000, //35秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      socketTimer: null,
      /**socket 通讯 结束 */
      openIdEn: "",
      ISSHOWCDH: "1",
      loadDebounceTimer: null,
      isLoadingMainData: false,
      hasPendingRefresh: false,
      // 日期筛选相关
      dateList: [],
      selectedDate: "",
      // 返回顶部相关
      showBackTop: false
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    var jmdparam = this.$route.query.jmdparam;
    if (jmdparam === undefined || jmdparam === null || jmdparam.length === 0) {
    } else {
      this.bsztSelectData = { name: "全部", value: "" };
      this.paramS = jmdparam;
      this.search.info = jmdparam;
    }
    this.search.queryType = this.$route.query.queryType;
    if (this.search.queryType === "my") {
      var ryInfo = this.utilPost.getLogin();
      if (ryInfo.isLogin) {
        this.search.telEn = ryInfo.TELEN;
      }
    }
  },
  computed: {},
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var that = this;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {
        that.openIdEn = openId;
      });
    } else {
      this.openIdEn = openIdEn;
    }
    this.dataList = [];
    //必须等界面渲染完成后 在加载
    this.generateDateList();

    this.initWebSocket();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    //页面销毁时关闭长连接
    this.websocketclose();
    clearInterval(this.socketTimer);
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      // 当滚动超过300px时显示返回顶部按钮
      this.showBackTop = window.pageYOffset > 300;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // 平滑滚动
      });
    },
    scheduleMainLoad(messageList) {
      console.log("ttttttt");
      this.hasPendingRefresh = true;
      if (this.loadDebounceTimer) {
        clearTimeout(this.loadDebounceTimer);
      }
      this.loadDebounceTimer = setTimeout(async () => {
        // 若正在请求，等它结束后再补一次
        if (this.isLoadingMainData) return;
        this.isLoadingMainData = true;
        this.hasPendingRefresh = false;
        try {
          const now = new Date();
          const pad = n => String(n).padStart(2, "0");
          const timeStr =
            `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
              now.getDate()
            )} ` +
            `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
              now.getSeconds()
            )}`;
          console.log("接口访问执行时间：" + timeStr);
          await this.mainDataNoLoading(messageList);
        } finally {
          this.isLoadingMainData = false;
          // 请求期间若又来了消息，可补发一次
          if (this.hasPendingRefresh) {
            this.scheduleMainLoad(messageList);
          }
        }
      }, 30000); // 150毫秒窗口
    },
    getTeamSumBsys(itemList) {
      var sumBsys = 0;
      for (var i = 0; i < itemList.length; i++) {
        sumBsys += itemList[i].BCYS - 0;
      }
      return sumBsys;
    },
    searchHandler() {
      this.dataList = [];
      this.pageSet.currentPage = 1;
      this.mainData();
    },
    refshData() {
      this.dataList = [];
      this.mainData();
    },
    loadingGdHandler() {
      if (this.isEndPage) {
        return;
      }
      this.pageSet.currentPage = this.pageSet.currentPage + 1;
      this.mainData();
    },
    mainData() {
      this.search.sslx = this.sslxSelectData.value;
      this.search.bszt = this.bsztSelectData.value;
      if (this.bsztSelectData.name === "比赛中,未开赛") {
        this.search.bszt = "0,1";
      }
      this.search.cdh = this.cdhActive;
      var busData = {
        pageSet: this.pageSet,
        search: this.search,
        selectedDate: this.selectedDate
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getSsbfData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //console.log(data);
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.ISSHOWCDH = data.lsData.ISSHOWCDH;
        if (
          data.content.DATALIST.length == 0 ||
          data.totalCount === this.pageSet.currentPage
        ) {
          this.isEndPage = true;
        } else {
          this.isEndPage = false;
        }
        for (var u = 0; u < data.content.DATALIST.length; u++) {
          this.dataList.push(data.content.DATALIST[u]);
        }
        var SSLXLIST = data.content.SSLXLIST;
        this.sslxActions = [
          {
            name: "全部",
            value: ""
          }
        ];

        for (var i = 0; i < SSLXLIST.length; i++) {
          var item = {
            name: SSLXLIST[i].SSLXMC,
            value: SSLXLIST[i].SSLX
          };
          this.sslxActions.push(item);
        }
        this.CDHLIST = data.content.CDHLIST;
      });
    },
    openSslxModal() {
      this.sslxVisible = true;
    },
    onSslxSelect(item) {
      this.pageSet.currentPage = 1;
      this.sslxSelectData = item;
      this.sslxVisible = false;
      this.dataList = [];
      this.mainData();
    },
    //打开比赛状态Model
    openBsztModal() {
      this.bsztShow = true;
    },
    onBsztSelect(item) {
      this.pageSet.currentPage = 1;
      this.bsztSelectData = item;
      this.bsztShow = false;
      this.dataList = [];
      this.mainData();
    },
    onTopClickLeft() {
      if (this.paramS.length === 0) {
        this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
      } else {
        this.$router.go(-1);
      }
    },
    navToBfMx(mxItem) {
      this.$router.push({
        path: "/ssbfMxIndex",
        query: { ssid: this.ssid, cch: mxItem.CCH, sxh: mxItem.SXH }
      });
    },
    /**webSocket 开始 */
    mainDataNoLoading(messageList) {
      this.search.sslx = this.sslxSelectData.value;
      this.search.bszt = this.bsztSelectData.value;
      if (this.bsztSelectData.name === "比赛中,未开赛") {
        this.search.bszt = "0,1";
      }
      this.search.cdh = this.cdhActive;
      var busData = {
        pageSet: this.pageSet,
        search: this.search,
        messageList: [], //messageList
        selectedDate: this.selectedDate
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getSsbfData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPostNoLoading().then(data => {
        //console.log(data);
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }

        if (
          data.content.DATALIST.length == 0 ||
          data.totalCount === this.pageSet.currentPage
        ) {
          this.isEndPage = true;
        } else {
          this.isEndPage = false;
        }
        this.dataList = data.content.DATALIST;
        // let contentList = data.content.DATALIST;
        // for (var i = 0; i < this.dataList.length; i++) {
        //   var itemMain = this.dataList[i];
        //   var MXLIST = itemMain.MXLIST;
        //   for (var j = 0; j < MXLIST.length; j++) {
        //     var itemData = MXLIST[j];
        //     var sslxType = itemData.SSLX.substr(1, 2);

        //     var dataXMID = itemData.XMID;
        //     var dataCCH = itemData.CCH;
        //     var dataSXH = itemData.SXH + "";
        //     var dataSSID = itemData.SSID;

        //     for (var u = 0; u < contentList.length; u++) {
        //       let resMxList = contentList[u].MXLIST;
        //       for (var r = 0; r < resMxList.length; r++) {
        //         if (
        //           dataSSID === resMxList[r].SSID &&
        //           dataXMID === resMxList[r].XMID &&
        //           dataCCH === resMxList[r].CCH &&
        //           dataSXH === resMxList[r].SXH
        //         ) {
        //           //将比赛状态改成比赛中
        //           MXLIST[j] = resMxList[r];
        //         }
        //       }
        //     }
        //   }
        // }
      });
    },
    StringToHex(str) {
      if (str == "") return "";
      let hex = [];
      //hex.push("0x");
      for (var i = 0; i < str.length; i++) {
        hex.push(str.charCodeAt(i).toString(16));
      }
      return hex.join("");
    },
    initWebSocket() {
      //建立连接
      //初始化weosocket
      //const wsuri = "ws://sms.填写您的地址.com/websocket/" + this.charId; //ws地址
      var dt = new Date();
      let year = dt.getFullYear();
      let month = (dt.getMonth() + 1).toString().padStart(2, "0");
      let date = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      var paramWebSocket = year + month + date;
      var rsaData = this.utilPost.rsaEn(
        paramWebSocket + "|spjaSGGOv6OtzioNsfOZWAt6DL5LnlNz"
      );
      const wsuri =
        allParam.wapSocketUrl +
        "/" +
        this.ssid +
        "/" +
        encodeURIComponent(this.StringToHex(rsaData)) +
        "/" +
        this.openIdEn;
      //建立连接
      this.websock = new WebSocket(wsuri);
      //连接成功
      this.websock.onopen = event => {
        this.websocketonopen();
      };
      //连接错误
      this.websock.onerror = event => {
        this.websocketonerror(event);
      };
      //接收信息
      this.websock.onmessage = event => {
        this.websocketonmessage(event);
      };
      //连接关闭
      this.websock.onclose = event => {
        this.websocketclose(event);
      };
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      clearInterval(this.socketTimer);
      this.socketTimer = setInterval(() => {
        console.log("重发心跳，状态" + self.websock.readyState);
        //重发心跳时  重新获取数据
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.websock.readyState == 1) {
          //如果连接正常
          self.websock.send("heartCheck");
        } else {
          //否则重连
          self.reconnect();
        }
      }, 30000);
    },

    websocketonopen() {
      //连接成功事件

      //提示成功
      console.log("连接成功");
      //开启心跳
      this.start();
    },

    websocketonerror(e) {
      //连接失败事件
      //错误
      console.log("WebSocket连接发生错误");
      //重连
      this.reconnect();
    },
    websocketclose(e) {
      //连接关闭事件
      //关闭
      console.log("关闭连接");
      //重连
      // this.reconnect();
      if (this.websock) {
        this.websock.close();
        console.log("WebSocket连接已关闭");
      }
    },
    byteToString(arr) {
      if (typeof arr === "string") {
        return arr;
      }
      var str = "",
        _arr = arr;
      for (var i = 0; i < _arr.length; i++) {
        var one = _arr[i].toString(2),
          v = one.match(/^1+?(?=0)/);
        if (v && one.length == 8) {
          var bytesLength = v[0].length;
          var store = _arr[i].toString(2).slice(7 - bytesLength);
          for (var st = 1; st < bytesLength; st++) {
            store += _arr[st + i].toString(2).slice(2);
          }
          str += String.fromCharCode(parseInt(store, 2));
          i += bytesLength - 1;
        } else {
          str += String.fromCharCode(_arr[i]);
        }
      }
      return str;
    },
    websocketonmessage(event) {
      //接收服务器推送的信息
      setTimeout(() => {
        // console.log("socket接收的：", event.data);
        var signRes = this.utilPost.verifySign(event.data);
        if (!signRes.isSign) {
          return;
        }
        var resultJob = JSON.parse(signRes.jsonMsg);
        var CJLIST = resultJob.CJLIST;
        var socketXMID = resultJob.XMID;
        var socketCCH = resultJob.CCH;
        var socketSSID = resultJob.SSID;
        var socketSXH = resultJob.SXH + "";
        for (var i = 0; i < this.dataList.length; i++) {
          var itemMain = this.dataList[i];
          var MXLIST = itemMain.MXLIST;
          for (var j = 0; j < MXLIST.length; j++) {
            var itemData = MXLIST[j];
            var sslxType = itemData.SSLX.substr(1, 2);

            var dataXMID = itemData.XMID;
            var dataCCH = itemData.CCH;
            var dataSXH = itemData.SXH + "";
            var dataSSID = itemData.SSID;
            if (
              dataSSID === socketSSID &&
              dataXMID === socketXMID &&
              dataCCH === socketCCH &&
              dataSXH === socketSXH
            ) {
              //将比赛状态改成比赛中
              if (sslxType === "T") {
                itemData.TEAMISKS = "1";
              } else {
                itemData.TEAMISKS = "1";
                itemData.ISKS = "1";
              }
              // itemData.CJLIST = CJLIST;
              if (CJLIST.length === 0) {
                //比赛完成了，从新加载界面
                let messageList = [];
                messageList.push(
                  socketSSID +
                    "-" +
                    socketXMID +
                    "-" +
                    socketCCH +
                    "-" +
                    socketSXH
                );
                this.scheduleMainLoad(messageList);
              } else {
                itemData.CJLIST = CJLIST;
              }
            }
          }
        }
      }, 10);

      // //收到服务器信息，心跳重置
      // this.reset();
    },
    websocketsend(msg) {
      //向服务器发送信息
      //数据发送
      this.websock.send(msg);
    },
    /**webSocket 结束 */
    // 生成日期列表（前后各7天）
    generateDateList() {
      //获取比赛日期
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getTrainDate" //对应的方法名
        },
        busData: {} //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        this.dateList = data.content;
        // 默认选中全部
        this.selectedDate = "";
        this.mainData(); //页面刚进入时开启长连接
      });
    },
    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 格式化日期显示（日）
    formatDateDay(dateStr) {
      const date = new Date(dateStr);
      return String(date.getDate()).padStart(2, "0");
    },
    // 格式化日期显示（月-日）
    formatDateMonth(dateStr) {
      const date = new Date(dateStr);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${month}-${day}`;
    },
    // 选择日期
    selectDate(date) {
      this.selectedDate = date;
      // 重新加载数据
      this.dataList = [];
      this.pageSet.currentPage = 1;
      this.mainData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.titleMainClass {
  text-align: center;
  padding: 10px;
  border-bottom: 1px solid rgb(221, 221, 221);
  font-size: 16px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-weight: 600;
}
/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}
/deep/ .van-tabs__nav {
  margin: 0px !important;
  border: 1px solid rgb(24, 95, 155) !important  ;
}
/deep/ .van-tab.van-tab--active {
  background-color: rgb(24, 95, 155) !important;
}
/deep/ .van-tab {
  border-right: 1px solid rgb(24, 95, 155);
  color: rgb(24, 95, 155);
}
/deep/ .van-cell--cente {
  padding: 6px !important;
}
.van-field {
  padding: 3px;
  border-radius: 5px;
}
.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.itemContentMain {
  background: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  position: relative;
}
.van-image--round {
  margin-top: 15px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.textMainDiv {
  padding-top: 15px;
}
.van-button--warning {
  width: 300px;
  height: 35px;
}

/* 日期筛选器样式 */
.date-filter-container {
  background: #fff;
  padding: 6px 0;
  border-bottom: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.date-filter-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 6px;
  gap: 4px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.date-filter-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.date-item {
  flex-shrink: 0;
  min-width: 36px;
  padding: 3px 5px;
  background: #f5f5f5;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.date-item:active {
  transform: scale(0.95);
}

.date-item.active {
  background: linear-gradient(135deg, #1989fa 0%, #1677d9 100%);
  border-color: #1989fa;
  box-shadow: 0 2px 6px rgba(25, 137, 250, 0.3);
}

.date-day {
  font-size: 13px;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
  margin-bottom: 1px;
}

.date-item.active .date-day {
  color: #fff;
}

.date-month {
  font-size: 9px;
  color: #999;
  line-height: 1;
}

.date-item.active .date-month {
  color: rgba(255, 255, 255, 0.9);
}

/* 全部选项样式 */
.date-item-all {
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.date-all-text {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.date-item-all.active .date-all-text {
  color: #fff;
}

/* 返回顶部按钮样式 */
.back-to-top {
  position: fixed;
  right: 12px;
  bottom: 80px;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #1989fa 0%, #1677d9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(25, 137, 250, 0.35);
  z-index: 999;
  transition: all 0.3s ease;
  animation: fadeInUp 0.3s ease;
}

.back-to-top:active {
  transform: scale(0.9);
}

.back-to-top .van-icon {
  color: #fff;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SsbfIndex/SsbfIndex.vue